module.exports = __webpack_public_path__ + "img/icon_sel@3x.a645de00.png";